import { Dispatch } from "react";
import { AllergenFormSection } from "../../Allergen/AllergenFormSection";
import { RecipeFormAction, RecipeFormState } from "./utils";

interface RecipeFormAllergensProps {
  state: RecipeFormState;
  dispatch: Dispatch<RecipeFormAction>;
  disabled?: boolean;
}

export const RecipeFormAllergens = ({ state, dispatch, disabled }: RecipeFormAllergensProps) => (
  <AllergenFormSection
    state={state}
    unavailableTooltipKey="allergenFree.unavailableTooltip"
    disabled={disabled}
    onChangeSelfAllergens={value => dispatch({ type: "CHANGE_SELF_ALLERGENS", value })}
    onChangeAllergenFree={value => dispatch({ type: "CHANGE_ALLERGEN_FREE", value })}
  />
);
